export default __webpack_public_path__ + "static/media/mxmERun.2e8213ac.jfif";